import React, { useEffect, useRef, useState } from "react";

import {
  PAIRED_UPDATE_LABEL,
  clickHitsTarget,
  nextPairedUpdateClicks,
} from "../pairedUpdateStamp";
import "./PairedUpdateTarget.css";

export default function PairedUpdateTarget({ children }) {
  const [visible, setVisible] = useState(false);
  const countRef = useRef(0);
  const lastRef = useRef(null);
  const rootRef = useRef(null);
  const visibleRef = useRef(false);
  visibleRef.current = visible;

  useEffect(() => {
    function onClick(event) {
      const root = rootRef.current;
      if (!root) return;
      const img = root.querySelector("img") || root;
      const rect = img.getBoundingClientRect();
      if (!clickHitsTarget(event.clientX, event.clientY, rect)) return;

      event.preventDefault();
      event.stopPropagation();

      if (visibleRef.current) {
        setVisible(false);
        countRef.current = 0;
        lastRef.current = null;
        return;
      }

      const now = Date.now();
      const step = nextPairedUpdateClicks(
        countRef.current,
        now,
        lastRef.current
      );
      countRef.current = step.count;
      lastRef.current = now;
      if (step.revealed) setVisible(true);
    }

    window.addEventListener("click", onClick, true);
    return () => window.removeEventListener("click", onClick, true);
  }, []);

  return (
    <span ref={rootRef} style={{ display: "inline-block" }}>
      {children}
      {visible ? (
        <span className="paired-update-label">{PAIRED_UPDATE_LABEL}</span>
      ) : null}
    </span>
  );
}
